import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoryRequestQuery extends AbstractGraphqlRequest<
  ServiceCategoryModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOneServiceCategory(
        $id: GqlEntityIdType!
        $payload: ServiceCategoryRequestPayloadInput
      ) {
        findOneServiceCategory(id: $id, payload: $payload) {
          id
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          shortDescription
          data {
            leftColor
            rightColor
          }
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOneServiceCategory;

    if (item) {
      return new ServiceCategoryModel(item);
    }

    return new ItemNotFound();
  }
}
